import { useMemo } from 'react';

import { Modal, Text, WarningIcon } from '@thefarmersfront/kitchen';

import { Table } from '~/components/common';

import { getDeliveryAgencyOrderInsufficientAddressColumnDefs } from '~/utils/delivery-agency/table';

import type { TypeDeliveryAgencyOrdersUploadResult } from '~/types/delivery-agency.types';

import styles from './DeliveryAgencyOrderInsufficientAddressModal.module.scss';

const TABLE_HEIGHT = 238;

const DeliveryAgencyOrderInsufficientAddressModal = ({
  open,
  addresses,
  onReattach,
  onProceed,
}: {
  open: boolean;
  addresses: NonNullable<TypeDeliveryAgencyOrdersUploadResult['insufficientAddresses']>;
  onReattach: () => void;
  onProceed: () => void;
}) => {
  const { columnDefs } = useMemo(() => getDeliveryAgencyOrderInsufficientAddressColumnDefs(), []);

  return (
    <Modal
      title={
        <div className={styles['title']}>
          상세주소 확인 필요 주문
          <div className={styles['guide']}>
            <WarningIcon className={styles['warning-icon']} size={32} color="#E22D2E" />
            <ul className={styles['guide-list']}>
              <li>
                <Text size="large" color="secondary" element="span">
                  입력하신 주소 중 정확한 상세 주소를(동/호수) 알 수 없는 주소가 {addresses.length}개 존재합니다.
                </Text>
              </li>
              <li>
                <Text size="large" color="secondary" element="span">
                  상세 주소가 부정확할 경우 배송이 어려울 수 있습니다. 입력한 주소를 다시 한번 확인해주세요.
                </Text>
              </li>
            </ul>
          </div>
        </div>
      }
      size="large"
      depth={2}
      open={open}
      cancelText="엑셀 다시 첨부하기"
      confirmText="이대로 진행하기"
      onCancel={onReattach}
      onConfirm={onProceed}
    >
      <div className={styles['table-container']}>
        <Table data={addresses} columns={columnDefs} height={TABLE_HEIGHT} />
      </div>
    </Modal>
  );
};

export default DeliveryAgencyOrderInsufficientAddressModal;
